import { useRef } from 'react';
import { Order } from '../../../../../types/apiResponse/order';
import OrderEditorModal from '../OrderEditorModal';
import { OrderDetailsTab } from './OrderDetailsContent';

type Props = {
  showModal: boolean;
  closeModal: () => void;
  order: Order;
  initialTab?: OrderDetailsTab;
  onPendenciesChanged?: () => void;
};

const stages: Record<OrderDetailsTab, string> = {
  summary: 'resumo', general: 'tipo', customer: 'cliente', seller: 'cliente',
  commercial: 'pagamento', delivery: 'entrega', items: 'itens', approval: 'pendencias-aprovacao',
};

/** All Admin entry points now use the same viewer and custom pages as the Sales. */
export default function OrderDetailsModal({ showModal, closeModal, order, initialTab = 'summary',
  onPendenciesChanged }: Props) {
  const changed = useRef(false);
  if (!showModal) return null;
  return <OrderEditorModal order={order} access="view" initialStage={stages[initialTab]}
    onClose={() => { closeModal(); if (changed.current) onPendenciesChanged?.(); }}
    onSaved={() => { changed.current = true; }} />;
}
